export default __webpack_public_path__ + "static/media/kiwisupercocktail@2x.b44e2fe3.jpg";